/** Date keys already name account calendar dates; UTC only formats their labels. */
export function formatCheckInDate(
  date: string,
  language: string,
  options: Intl.DateTimeFormatOptions,
): string {
  return new Intl.DateTimeFormat(language === 'tw' ? 'zh-TW' : language, {
    ...options,
    timeZone: 'UTC',
  }).format(new Date(`${date}T00:00:00Z`))
}

/** ISO construction preserves literal calendar years below 100. */
export function shiftCheckInDate(date: string, offset: number): string {
  const result = new Date(`${date}T00:00:00Z`)
  result.setUTCDate(result.getUTCDate() + offset)
  return result.toISOString().slice(0, 10)
}
